(() => {
  const init = () => {
    const card = document.querySelector('[data-kz-motopump]');
    const reviews = document.querySelector('.shopify-section--kruzer-store-reviews');
    if (!card || !reviews || reviews.dataset.kzMotopumpFixed === 'true') return;

    card.insertAdjacentElement('afterend', reviews);
    reviews.dataset.kzMotopumpFixed = 'true';

    const lead = reviews.querySelector('.kz-store-reviews__lead');
    if (lead) lead.innerHTML = '<p>Ta ocena dotyczy doświadczeń klientów ze sklepem KRUZER — obsługi, dostawy i zgodności zamówienia. Nie jest oceną techniczną tej motopompy.</p>';

    const heading = reviews.querySelector('.kz-store-reviews__footer h3');
    if (heading) heading.textContent = 'Zaufanie do sklepu to jedno. Motopompa musi jeszcze pasować do rodzaju wody i instalacji.';

    const text = reviews.querySelector('.kz-store-reviews__footer p');
    if (text) text.textContent = 'Porównaj modele, sprawdź wydajność, wysokość podnoszenia i średnicę przyłączy albo skontaktuj się z KRUZER przed zakupem.';

    const primary = reviews.querySelector('.kz-store-reviews__button--primary');
    if (primary) {
      primary.textContent = 'Porównaj motopompy';
      const comparison = card.querySelector('[id^="kz-mp-compare-"]');
      if (comparison) primary.setAttribute('href', '#' + comparison.id);
    }

    const secondary = reviews.querySelector('.kz-store-reviews__button--secondary');
    if (secondary) {
      secondary.textContent = 'Skontaktuj się';
      secondary.setAttribute('href', '/pages/contact');
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', init);
})();
